/**
 * Look of the three status columns of the participants grid (Inscripción, Pago, Asistencia).
 * One tone set for all of them: green = done, amber = someone must act, red = problem,
 * grey = nothing happened yet.
 */

import type { LucideIcon } from 'lucide-react';
import { Check, CircleDashed, Clock, RotateCcw, X } from 'lucide-react';

export type StatusTone = 'success' | 'warning' | 'danger' | 'neutral';

export interface StatusLook {
  tone: StatusTone;
  label: string;
  icon: LucideIcon;
}

export function registrationLook(status: string | null | undefined): StatusLook {
  switch (status) {
    case 'PRE_REGISTERED':
      return { tone: 'warning', label: 'Por revisar', icon: Clock };
    case 'REJECTED':
      return { tone: 'danger', label: 'Rechazada', icon: X };
    default:
      return { tone: 'success', label: 'Verificada', icon: Check };
  }
}

export function paymentLook(status: string | null | undefined): StatusLook {
  switch (status) {
    case 'PAID':
      return { tone: 'success', label: 'Pagado', icon: Check };
    case 'PARTIAL':
      return { tone: 'warning', label: 'Parcial', icon: CircleDashed };
    case 'REVERSED':
      return { tone: 'danger', label: 'Revertido', icon: RotateCcw };
    default:
      return { tone: 'neutral', label: 'Pendiente', icon: CircleDashed };
  }
}

export function attendanceLook(status: string | null | undefined): StatusLook {
  switch (status) {
    case 'ATTENDED':
      return { tone: 'success', label: 'Asistió', icon: Check };
    case 'ABSENT':
      return { tone: 'danger', label: 'Ausente', icon: X };
    default:
      return { tone: 'neutral', label: 'Pendiente', icon: CircleDashed };
  }
}
